import React from "react";
import BuildPackageTicketScreen from "../../../common/AllTickets/BuildPackage/BuildPackageTicketScreen";

const UserBuildPackageTicket = () => {
  return <BuildPackageTicketScreen mode="USER" />;
};
export default UserBuildPackageTicket;
